var _mask, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _ellipse, _ellipse2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReachLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 102,
    viewBox: "0 0 87 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 84,
    height: 99,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3,
    width: 84,
    height: 99
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0884 96.9998H5.52009L8.78043 83.3327L5.52009 69.9168L6.29388 54.5471L5 14.0371L5.52009 2.79529L24.204 4.34909L35.7111 2H49.673L67.4099 8.73782L76.5437 19.9274L78.6612 31.5593L77.8788 41.6341L74.92 50.6891L64.336 57.1642L85 96.9998H56.6766L42.5146 68.0297L29.6603 60.3738L28.6801 76.8667L30.0884 96.9998ZM42.927 43.9271L30.0879 42.3685L30.7588 22.1943L51.566 25.4055L55.9141 36.3504L42.927 43.9271Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52009 96.9998L4.06103 96.6518C3.95451 97.0983 4.05832 97.569 4.34278 97.9293C4.62724 98.2896 5.06103 98.4998 5.52009 98.4998V96.9998ZM30.0884 96.9998V98.4998C30.5044 98.4998 30.9018 98.3271 31.1855 98.0228C31.4692 97.7186 31.6138 97.3102 31.5848 96.8952L30.0884 96.9998ZM8.78043 83.3327L10.2395 83.6807C10.2946 83.4498 10.2941 83.2091 10.238 82.9784L8.78043 83.3327ZM5.52009 69.9168L4.02198 69.8414C4.01471 69.9858 4.02836 70.1305 4.06251 70.271L5.52009 69.9168ZM6.29388 54.5471L7.79198 54.6225C7.79405 54.5814 7.79442 54.5403 7.79311 54.4992L6.29388 54.5471ZM5 14.0371L3.5016 13.9678C3.4998 14.0068 3.49952 14.0459 3.50076 14.085L5 14.0371ZM5.52009 2.79529L5.6444 1.30045C5.23842 1.26669 4.83617 1.39951 4.53011 1.66837C4.22405 1.93724 4.04052 2.31903 4.02169 2.72597L5.52009 2.79529ZM24.204 4.34909L24.0797 5.84393C24.2216 5.85574 24.3645 5.84727 24.504 5.81878L24.204 4.34909ZM35.7111 2V0.5C35.6103 0.5 35.5098 0.510155 35.4111 0.530312L35.7111 2ZM49.673 2L50.2057 0.597767C50.0355 0.533129 49.855 0.5 49.673 0.5V2ZM67.4099 8.73782L68.5719 7.78929C68.4055 7.58548 68.1885 7.42902 67.9425 7.33559L67.4099 8.73782ZM76.5437 19.9274L78.0194 19.6587C77.974 19.4092 77.8661 19.1753 77.7057 18.9789L76.5437 19.9274ZM78.6612 31.5593L80.1567 31.6754C80.1667 31.5468 80.1601 31.4175 80.137 31.2906L78.6612 31.5593ZM77.8788 41.6341L79.3046 42.1C79.3417 41.9866 79.365 41.8692 79.3743 41.7502L77.8788 41.6341ZM74.92 50.6891L75.7028 51.9686C76.0071 51.7825 76.235 51.494 76.3458 51.155L74.92 50.6891ZM64.336 57.1642L63.5532 55.8847C62.8816 56.2956 62.642 57.156 63.0045 57.8549L64.336 57.1642ZM85 96.9998V98.4998C85.5238 98.4998 86.0097 98.2266 86.2818 97.7789C86.5539 97.3313 86.5727 96.7741 86.3315 96.3091L85 96.9998ZM56.6766 96.9998L55.329 97.6586C55.5806 98.1734 56.1036 98.4998 56.6766 98.4998V96.9998ZM42.5146 68.0297L43.8622 67.371C43.7342 67.1091 43.5326 66.8902 43.2822 66.741L42.5146 68.0297ZM29.6603 60.3738L30.4279 59.0851C29.978 58.8171 29.4209 58.8032 28.9582 59.0483C28.4954 59.2934 28.194 59.7621 28.163 60.2848L29.6603 60.3738ZM28.6801 76.8667L27.1827 76.7777C27.1789 76.8422 27.1793 76.9069 27.1838 76.9714L28.6801 76.8667ZM30.0879 42.3685L28.5887 42.3187C28.5629 43.0958 29.1352 43.7639 29.9071 43.8576L30.0879 42.3685ZM42.927 43.9271L42.7463 45.4161C43.0712 45.4556 43.4002 45.3877 43.6829 45.2227L42.927 43.9271ZM30.7588 22.1943L30.9875 20.7119C30.5635 20.6464 30.1317 20.7657 29.8014 21.0396C29.4711 21.3134 29.2738 21.7156 29.2596 22.1444L30.7588 22.1943ZM51.566 25.4055L52.96 24.8517C52.7637 24.3575 52.3203 24.0042 51.7948 23.9231L51.566 25.4055ZM55.9141 36.3504L56.6699 37.6461C57.3107 37.2722 57.582 36.4861 57.3081 35.7966L55.9141 36.3504ZM5.52009 98.4998H30.0884V95.4998H5.52009V98.4998ZM7.32137 82.9846L4.06103 96.6518L6.97915 97.3479L10.2395 83.6807L7.32137 82.9846ZM4.06251 70.271L7.32286 83.6869L10.238 82.9784L6.97766 69.5626L4.06251 70.271ZM4.79577 54.4716L4.02198 69.8414L7.01819 69.9922L7.79198 54.6225L4.79577 54.4716ZM3.50076 14.085L4.79464 54.5949L7.79311 54.4992L6.49924 13.9892L3.50076 14.085ZM4.02169 2.72597L3.5016 13.9678L6.4984 14.1064L7.01848 2.86462L4.02169 2.72597ZM24.3283 2.85425L5.6444 1.30045L5.39577 4.29013L24.0797 5.84393L24.3283 2.85425ZM35.4111 0.530312L23.904 2.87941L24.504 5.81878L36.0111 3.46969L35.4111 0.530312ZM49.673 0.5H35.7111V3.5H49.673V0.5ZM67.9425 7.33559L50.2057 0.597767L49.1403 3.40223L66.8772 10.1401L67.9425 7.33559ZM77.7057 18.9789L68.5719 7.78929L66.2479 9.68635L75.3817 20.8759L77.7057 18.9789ZM80.137 31.2906L78.0194 19.6587L75.0679 20.1961L77.1855 31.8279L80.137 31.2906ZM79.3743 41.7502L80.1567 31.6754L77.1657 31.4431L76.3833 41.5179L79.3743 41.7502ZM76.3458 51.155L79.3046 42.1L76.453 41.1682L73.4942 50.2232L76.3458 51.155ZM65.1189 58.4438L75.7028 51.9686L74.1372 49.4095L63.5532 55.8847L65.1189 58.4438ZM86.3315 96.3091L65.6676 56.4735L63.0045 57.8549L83.6685 97.6905L86.3315 96.3091ZM56.6766 98.4998H85V95.4998H56.6766V98.4998ZM41.167 68.6885L55.329 97.6586L58.0242 96.3411L43.8622 67.371L41.167 68.6885ZM28.8927 61.6625L41.747 69.3185L43.2822 66.741L30.4279 59.0851L28.8927 61.6625ZM30.1775 76.9557L31.1577 60.4628L28.163 60.2848L27.1827 76.7777L30.1775 76.9557ZM31.5848 96.8952L30.1764 76.762L27.1838 76.9714L28.5921 97.1045L31.5848 96.8952ZM29.9071 43.8576L42.7463 45.4161L43.1078 42.438L30.2686 40.8795L29.9071 43.8576ZM29.2596 22.1444L28.5887 42.3187L31.5871 42.4184L32.2579 22.2442L29.2596 22.1444ZM51.7948 23.9231L30.9875 20.7119L30.53 23.6768L51.3372 26.888L51.7948 23.9231ZM57.3081 35.7966L52.96 24.8517L50.172 25.9593L54.5201 36.9043L57.3081 35.7966ZM43.6829 45.2227L56.6699 37.6461L55.1582 35.0548L42.1712 42.6314L43.6829 45.2227Z",
    fill: "white",
    mask: "url(#path-1-outside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0877 96.9998L21.1098 89.5206L28.6793 76.8667L19.5937 65.29L29.6595 60.3738L19.5937 54.5576H6.50586L11.0483 69.6325L8.77965 83.3327",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52148 96.9998L21.112 89.5205L19.4765 96.9998",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1099 89.5206L8.77977 83.3327L28.6794 76.8667L11.0484 69.6325L19.5938 65.29V54.5576L5.82617 69.6325",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1099 89.5201L11.0484 69.632L19.5938 54.5571L18.2969 41.9182L5.82617 33.8917L23.5406 29.8887L29.6634 42.368L30.0878 60.4925L36.6318 52.2581L43.2494 44.0736L46.7107 64.1935L29.6634 60.2762",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50586 54.5569L18.2968 41.918L36.6317 52.2579L46.7105 63.4561L71.0532 70.1493L49.0827 81.2515L71.513 96.6367L79.3477 86.1309L52.0224 79.009L56.7701 96.6367L62.7917 81.2515L55.9138 66.0589L42.5138 68.0291",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82617 43.297L18.2969 41.918L42.9269 43.8405L64.3354 57.1635L46.7107 63.4561L42.5139 68.0291L51.2124 49.4992L19.5938 54.5569C19.5938 54.5569 28.7308 43.3387 29.6634 42.3678L37.0181 52.0783L42.5139 68.0291",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82683 33.4032L15.1077 16.079L24.204 4.3495L5 13.5273L23.5412 29.8896L30.7593 22.1947L15.1077 16.079L5.82683 2.90039",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5269L15.1077 16.0786L35.0814 10.9855L49.673 2L48.0389 16.0786L30.7593 22.1943L24.204 4.34909L35.0814 10.9855L47.6564 16.7102L51.9517 25.4055L30.7593 22.2631L34.5383 10.9855L35.7111 2L47.6564 16.7102L65.8733 27.2557L76.5437 19.9274L65.463 13.5269L65.8733 46.22L55.8356 36.6451L65.8733 27.2557L51.4109 25.4055L55.8356 36.6451L42.9276 43.8412",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1074 16.0791L23.541 29.8896L18.2973 41.413",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6735 2L65.4635 13.5269L67.4104 8.73782L48.0394 16.0786L65.4635 13.5269L51.4113 25.4055",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.873 27.2559L78.2482 31.2767L65.873 46.2201L74.8489 50.3026",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8731 27.2559L77.5627 41.9188L64.3359 57.1643L65.8731 46.2201L51.5664 49.1454L55.8355 36.6452",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8789 41.6348L66.3672 46.2207",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5664 49.5L55.9145 66.0597L64.3359 57.1643",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5676 49.5L46.7124 63.4569L49.0845 81.2523L55.9157 66.0597L52.4725 78.8918L42.5156 68.0298",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0228 79.0099L46.7109 63.457",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0544 70.1494L62.793 81.2516L71.5142 96.6368",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0234 79.5898L62.7928 90.7018L78.7638 86.4451",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7708 96.6371L62.7924 90.7014V81.9228L49.3672 81.252",
    stroke: "white",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82617 70.1503L11.0484 69.6328",
    stroke: "white",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.6951,
    cy: 49.2591,
    rx: 1.57397,
    ry: 1.47686,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.9685,
    cy: 16.2767,
    rx: 1.57397,
    ry: 1.47686,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.771362,
    y: 84.7705,
    width: 25.0907,
    height: 16.9795,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0.320422 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 47.2734,
    y: 74.8398,
    width: 36.2406,
    height: 20.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0.320422 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachLogo);
export default __webpack_public_path__ + "static/media/reach-logo.35a696c416a57a3f046e5e3b5e19c1f3.svg";
export { ForwardRef as ReactComponent };